import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";

type StatItem = {
  valueFirst?: string;
  labelBefore?: string;
  labelAfter?: string;
};

const separators = [
  { src: "/images/stats-vector.svg", className: "h-3 w-[27px]" },
  { src: "/images/stats-group-23.svg", className: "h-[22px] w-[33px]" },
];

const SeparatorIcon: React.FC<{ index: number }> = ({ index }) => {
  const icon = separators[index % separators.length];

  return (
    <img
      src={icon.src}
      alt=""
      aria-hidden="true"
      className={`shrink-0 ${icon.className}`}
    />
  );
};

const StatText: React.FC<{ item: StatItem }> = ({ item }) => (
  <span className="whitespace-nowrap text-center font-sans text-xl font-semibold uppercase leading-[50px]">
    {item.labelBefore && <span className="text-white">{item.labelBefore} </span>}
    {item.valueFirst && <span className="text-main-color">{item.valueFirst}</span>}
    {item.labelAfter && <span className="text-white"> {item.labelAfter}</span>}
  </span>
);

const StatsMarqueeSection: React.FC = () => {
  const { t, dir } = useLanguage();
  const isRtl = dir === "rtl";
  const stats = ((t as any)?.homeStats?.items || [
    { valueFirst: "10+", labelAfter: "Years of Experience" },
    { valueFirst: "1,000+", labelAfter: "Students Enrolled" },
    { valueFirst: "20+", labelAfter: "Educational Partners" },
    { labelBefore: "Students from", valueFirst: "20+ Countries" },
  ]) as StatItem[];

  const marqueeItems = [...stats, ...stats];

  return (
    <section className="overflow-hidden bg-second-color py-4">
      <div className="relative flex w-full overflow-hidden">
        <div
          className={`flex min-w-max items-center gap-6 ${
            isRtl ? "animate-marquee-rtl" : "animate-marquee-ltr"
          }`}
        >
          {marqueeItems.map((item, index) => (
            <React.Fragment key={`${item.valueFirst || item.labelBefore}-${index}`}>
              <StatText item={item} />
              <SeparatorIcon index={index} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsMarqueeSection;
